const appInfo = {
    title: 'B’Logic'
};
export default appInfo;

